import { buildService } from '@rd-web-markets/shared/dist/services/service';
import serviceMethods from '@rd-web-markets/shared/dist/services/service_methods';
import { useCallback } from 'react';

const getBasePath = () => '/checklist_templates';

const service = buildService(getBasePath(), { only: ['all', 'create'] });

const checklistTemplateService = {
  useFetchAllTemplates: (setLoading) => {
    const [templates, setTemplates, fetchTemplates] = serviceMethods.useFetch({
      callback: useCallback(async () => {
        const response = await service.all();
        if (Array.isArray(response)) return response;
        if (response && typeof response === 'object') {
          const key = Object.keys(response).find(k => Array.isArray(response[k]));
          return key ? response[key] : [];
        }
        return [];
      }, []),
      setLoading,
      initialStateValue: []
    });

    return [templates, setTemplates, fetchTemplates];
  },

  useCreateTemplate: (setLoading, setTemplates, templates) => {
    const createTemplate = serviceMethods.useHttpCallback({
      callback: useCallback(async () => {
        const response = await service.create({});
        setTemplates([...templates, response]);
        return response;
      }, [templates, setTemplates]),
      setLoading
    });

    return [createTemplate];
  }
};

checklistTemplateService.useCrud = (setLoading) => {
  const [templates, setTemplates, fetchTemplates] = checklistTemplateService.useFetchAllTemplates(setLoading);
  const [createTemplate] = checklistTemplateService.useCreateTemplate(setLoading, setTemplates, templates);

  return {
    templates,
    setTemplates,
    fetchTemplates,
    createTemplate
  };
};

export default checklistTemplateService;